import { DEBUG } from "../js/debug";
import { SERVER_URL } from "../js/server";

const SERVER = SERVER_URL + "support-extra/";

export let post = async (funct, body) => {
  let endpoint = SERVER;
  endpoint = endpoint + funct;
  try {
    const response = await fetch(endpoint, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const textData = await response.text();
    let data;
    try {
      data = JSON.parse(textData);
    } catch (parseError) {
      if (DEBUG) {
        console.error(parseError.message, textData);
      } else {
        console.error(parseError.message);
      }
      throw parseError;
    }
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
        responseText: textData,
        responseJSON: data,
      };
      console.log(debug);
    }
    return data;
  } catch (e) {
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
      };
      console.log(debug);
    }
    console.error(e, funct);
  }
};
